import { useMutation } from '@tanstack/react-query';
import { initatePurchaseTerminalCheckout } from '../../services/business';
import useUser from '../global/useUser';

interface UsePurchaseTerminalReaderProps {
  onSuccess?: (
    data: Awaited<ReturnType<typeof initatePurchaseTerminalCheckout>>,
  ) => void;
  onError?: () => void;
}

function usePurchaseTerminalReader({
  onSuccess,
  onError,
}: UsePurchaseTerminalReaderProps = {}) {
  const { user } = useUser();
  const businessId = user?.business?.id;

  return useMutation({
    mutationFn: async (priceId: string) => {
      if (!businessId) throw new Error('Business is required');

      const successUrl = new URL(window.location.href);
      successUrl.searchParams.set('success', 'true');

      const checkoutSession = await initatePurchaseTerminalCheckout({
        priceId,
        businessId: businessId!,
        successUrl: successUrl.toString(),
      });

      return checkoutSession;
    },
    onSuccess,
    onError,
  });
}

export default usePurchaseTerminalReader;
